<template>
  <div class="container-fluid">
    <a href="http://kpmgportal.dig-x.co.in/login/">
      <img src="@/assets/images/dark-medium-home.svg" alt="#" v-if="theme =='dark' || theme == 'medium'" class="home-icon"/>
      <img src="@/assets/images/light-home.svg" alt="#" v-if="theme =='light'" class="home-icon"/>
    </a>
    <div class="row">
      <div class="col-12">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";


export default {
  name: "App",
  computed: {
    theme() {
      return store.getters.getCurrentTheme;
    },
    lang() {
      return store.getters.getCurrentLang;
    }
  },
  watch: {
    '$route' (to) {
        document.title = to.meta.title || 'Your Website'
    },
    theme( newValue, oldValue ){
      if( newValue != oldValue ) {
        this.setThemeToLocalStorage();
        this.applyThemeContext();
      }
    },
    lang( newValue, oldValue ){
      if( newValue != oldValue ) {
        this.setLangToLocalStorage();
        this.applyLangContext();
      }
    }
  },
  methods: {
    applyThemeContext: function () {

      if( window.localStorage.getItem('theme') == 'light' ) { 
        document.body.classList.remove('theme-dark');
        document.body.classList.remove('theme-medium');
        document.body.classList.add('theme-light');

      } else if ( window.localStorage.getItem('theme')  == 'dark' ) {
        document.body.classList.remove('theme-light');
        document.body.classList.remove('theme-medium');
        document.body.classList.add('theme-dark');
        
      } else if ( window.localStorage.getItem('theme')  == 'medium' ) {
        document.body.classList.remove('theme-light');
        document.body.classList.remove('theme-dark');
        document.body.classList.add('theme-medium');
      }
    },
    applyLangContext: function() {
      // New code fetching from Local Storage
      if( window.localStorage.getItem('lang') == 'ar' ) {
        document.body.classList.remove('en');
        document.body.classList.add('ar');
      } else if ( window.localStorage.getItem('lang')  == 'en' ) {
        document.body.classList.remove('ar');
        document.body.classList.add('en');
      } 
    },
    setThemeToLocalStorage: function() {
      window.localStorage.setItem('theme',store.getters.getCurrentTheme);
    },
    setLangToLocalStorage: function() {
      window.localStorage.setItem('lang',store.getters.getCurrentLang);
    },
    setDimensions: function() {
      let width = window.innerWidth;
      let body = document.getElementById('body');
      console.log(body.style.paddingLeft);
      body.style.paddingLeft = (width - 1440) / 2 + 'px';
      body.style.paddingRight = (width - 1440) / 2 + 'px';
      window.onresize  = this.setDimensions;
    }
  },
  mounted() {
    // Set Dimensions
    this.setDimensions();

    // Set Theme And Lang
    this.setThemeToLocalStorage();
    this.setLangToLocalStorage();
    this.applyThemeContext();
    this.applyLangContext();
  }
};
</script>

<style lang="scss">
@import "@/assets/css/global.scss";
// Globals for chart labels
.home-icon {
  position: absolute;
  top: 60px;
  left: 30px;
  width: 50px;
  cursor: pointer;
}
body.theme-light {
.highcharts-data-label {
    text-align: right;
    @include apply-font($almarai, 700, 12px, #4a7780);
    // letter-spacing: 1.91px;
    text {
      color: #4a7780 !important;
    }
  }
  .highcharts-text-outline {
    stroke: transparent !important;
    stroke-width: 0px !important;
  }
  .cust-chart-datalabel {
    @include apply-font($almarai, 700, 12px, #92adb2);
    .cust-label {
      width: 23px;
      height: 23px;
      border-radius: 20px;
      background-color: #48b0c4;
      position: absolute;
      margin-left: 10px;
      top: -5px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }
    .cust-label.left {
      left: -40px;
    }
  }
}
body.theme-medium {
  .highcharts-data-label {
    text-align: right;
    @include apply-font($almarai, 700, 12px, #4a7780);
    // letter-spacing: 1.91px;
    text {
      color: #4a7780 !important;
    }
  }
  .highcharts-text-outline {
    stroke: transparent !important;
    stroke-width: 0px !important;
  }
  .cust-chart-datalabel {
    @include apply-font($almarai, 700, 12px, #92adb2);
    .cust-label {
      width: 23px;
      height: 23px;
      border-radius: 20px;
      background-color: #48b0c4;
      position: absolute;
      margin-left: 10px;
      top: -5px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }
    .cust-label.left {
      left: -40px;
    }
  }

}
body.theme-dark {
  .highcharts-data-label {
    text-align: right;
    @include apply-font($almarai, 700, 12px, #4a7780);
    // letter-spacing: 1.91px;
    text {
      color: #4a7780 !important;
    }
  }
  .highcharts-text-outline {
    stroke: transparent !important;
    stroke-width: 0px !important;
  }
  .cust-chart-datalabel {
    @include apply-font($almarai, 700, 12px, #92adb2);
    .cust-label {
      width: 23px;
      height: 23px;
      border-radius: 20px;
      background-color: #48b0c4;
      position: absolute;
      margin-left: 10px;
      top: -5px;
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }
    .cust-label.left {
      left: -40px;
    }
  }
}

// Global Responsive
  @media (min-width: 1440px) {
    body {
      //  padding: 38px 18%;
    }
  }
  @media (min-width: 1440px) {
    body {
      // padding: 0px 89px;
    }
  }
  // `sm` applies to x-small devices (portrait phones, less than 576px)
  @media (max-width: 575.98px) {
    body {
      // padding: 0px 49px;
    }
    body.theme-light,.body.theme-medium,body.theme-dark {
      padding: 0px 10px !important;
    }
    .outer {
      padding: 15px 10px !important;
    }
    .header {
      height: auto !important;
      padding-bottom: 20px;
    }
    .logo-container,
    .dash-heading-container,
    .custom-dropdown-container {
      display: flex;
      justify-content: center !important;
    }
    .dash-heading-container {
      .line {
        bottom: 0px !important;
      }
    }
    .custom-dropdown-container {
      margin-top: 15px;
      display: inline-flex !important;
      flex-direction: row !important;
      align-items: center !important;
      padding-top: 20px;
      padding-bottom: 20px;
      .theme-toggler {
        margin-top: 0 !important;
      }
    }
    .tiles-section,.chart-container {
      display: block !important;
    }
    
    .tile-proto {
      margin-top: 10px;
      width: 100% !important;
      img.bg {
      }
    }
    .lg-tile-proto {
      height: auto !important;
      margin-top: 10px;
      margin-bottom: 10px;
      width: 100% !important;
      .tilehead {
        width: 100% !important;
      }
      .list {
        width: 100% !important;
      }
      .content-container {
       display: flex !important;
       flex-direction: column !important;
       padding-left: 0 !important;
      }
    }
    .chart-container {
    .chart-tile {
       width: 100% !important;
       height: auto;
       margin-bottom: 50px;
       .tilehead {
        width: 100% !important;
      }
      #cirpie1,#cirpie2,#cirpie3,#cirpie4 {
        width: 100% !important;
      }
    }
    }
    .risks,.issues {
      .table-tiles  {
        margin-left: 5px !important;
        margin-bottom: 10px !important;
        margin-right: 5px !important;
      }
    }
     .tab-data {
        display: flex !important;
        flex-direction: column !important;
        .tabs {
          margin-bottom: 10px !important;
        }
      }
      .markline-container {
        img {
          max-width: 300px !important;
          margin-top: 20px !important;

        }
      }
      .filter-data-tile {
        width: 100% !important;
        margin-bottom: 20px !important;
      }
  }
  // `md` applies to small devices (landscape phones, less than 768px)
  @media (max-width: 767.98px) {
  }
  // `lg` applies to medium devices (tablets, less than 992px)
  @media (max-width: 991.98px) {
  }
  // `xl` applies to large devices (desktops, less than 1200px)
  @media (max-width: 1199.98px) {
  }
  // `xxl` applies to x-large devices (large desktops, less than 1400px)
  @media (max-width: 1399.98px) {
    .tiles-section {
      flex-direction: column !important;
    }
    .lg-tile-proto {
      margin-bottom:50px;
      .content-container {
        display: flex !important;
        justify-content: center !important;
      }
    }
    .chart-container {
      flex-direction: column !important;
      align-items: center;

      .chart-tile {
        width: 100% !important;
        margin-bottom: 50px;

        .tilehead {
          width: 100% !important;
        }
      }
    }
    .theme-light.ar,.theme-medium.ar,.theme-dark.ar {
      .table-tiles {
        margin-left: 10px !important;
      }
      .filter-data-tile {
        margin-left: 4px !important;
      }
    }
    .theme-light.en,.theme-medium.en,.theme-dark.en {
      .table-tiles {
        margin-right: 10px !important;
      }
      .filter-data-tile {
        margin-right: 4px !important;
      }
    }

  }



</style>
